"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.QUERYSTRING_IFRAMEURL = void 0;
const QUERYSTRING_IFRAMEURL = exports.QUERYSTRING_IFRAMEURL = 'iframeUrl';
